import React from "react";
import "./CV.css";
import shihab_resume from "../../assests/resume/shihab_resume.pdf";
import { Download } from "lucide-react";

function CV() {
  return (
    <a
      href={shihab_resume}
      className="cv-btn"
      rel="noopener noreferrer"
      download
    >
      <Download size={15} /> <b className="resume"> resume</b>
    </a>
  );
}

export default CV;
